/** @file Writes a Sample's keyed discrete channels into a Pose: inherit, attachments, draw order, IK flags. */
import type { Pose } from '../contracts/pose';
import type { Sample } from '../contracts/sample';
import type { SkeletonData, SkinData } from '../skeletonData';
import { sampleIndex } from '../_internal/timeline/sampleIndex';
import { channelClass } from './channelClass';

/** Copies keyed discrete channels into pose; placeholder ids resolve through skin (unmapped or -1 shows nothing). */
export function applyDiscreteChannels(pose: Pose, data: SkeletonData, sample: Sample, skin: SkinData): void {
  for (let b = 0; b < sample.inherit.length; b++) {
    const mode = sample.inherit[b] ?? -1;
    if (mode >= 0) pose.inherit[b] = mode;
  }
  for (let s = 0; s < sample.attachments.length; s++) {
    const placeholder = sample.attachments[s] ?? -2;
    if (placeholder === -2) continue;
    pose.slotAttachment[s] = placeholder < 0 ? -1 : (skin.map.get(s)?.get(placeholder) ?? -1);
  }
  if (sample.drawOrderKeyed) pose.drawOrder.set(sample.drawOrder);
  // IK flags are the class-4 channels of the IK block; Sample index c is Pose.ik[c - ikStart].
  const slotStart = sampleIndex(data, 'slot', 0, 0);
  const ikStart = sampleIndex(data, 'ik', 0, 0);
  for (let c = ikStart; c < sample.values.length; c++) {
    if (sample.mask[c] === 1 && channelClass(c, slotStart, ikStart) === 4) pose.ik[c - ikStart] = sample.values[c] ?? 0;
  }
}
